<template>
    <div>
        <Backlink :back="{ name: 'models.view', params: { id: model_id } }" />
        <h2>{{ isEdit ? 'Modification' : 'Ajout' }} de tissu</h2>
        <!-- Form fields for the model would go here -->
        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="label_tissu" class="form-label">Nom</label>
                <input type="text" class="form-control" id="label_tissu" placeholder="Nom du tissu"
                    v-model="formData.label" required>
                <small class="text-danger" v-if="errors['label']">{{ errors['label'][0] }}</small>

            </div>

            <div class="mb-3 col-md-6">
                <label for="type_tissu" class="form-label">Type de tissu</label>
                <select id="type_tissu" class="form-select" aria-label="Default select example"
                    v-model="formData.type_tissu_id">
                    <option selected disabled value="">Type de tissu</option>
                    <option v-for="tissuType in tissuTypes" :key="'type_tissu' + tissuType.id" :value="tissuType.id">{{
                        tissuType.label
                        }}</option>
                </select>
            </div>

            <div class="mb-3 col-md-6">
                <label for="color_tissu" class="form-label">Couleur</label>
                <input type="text" class="form-control" id="color_tissu" placeholder="Couleur du tissu"
                    v-model="formData.color">
            </div>

            <div class="mb-3 col-md-6">
                <label for="quality_tissu" class="form-label">Qualité</label>
                <input type="text" class="form-control" id="quality_tissu" placeholder="Qualité du tissu"
                    v-model="formData.quality" required>
            </div>

            <div class="mb-3 col-md-6">
                <label for="quantity_tissu" class="form-label">Quantité</label>
                <input type="number" class="form-control" id="quantity_tissu" placeholder="Quantité du tissu"
                    v-model="formData.quantity" required>
            </div>


            <div class="mb-3 col-md-6">
                <label for="image_model" class="form-label">Image</label>
                <input type="file" class="form-control" id="image_model" placeholder="Image du modèle"
                    @change="takeFileInput($event, 'image')">
            </div>

            <div>
                <img :src="imageUrl" class="image-preview" />
            </div>

        </div>


        <div class="row mt-2">
            <div class="col text-end">
                <button class="btn btn-success" @click="save"><i
                        class="bi bi-check-circle me-1"></i>Enregistrer</button>
                <button type="button" class="btn btn-secondary mx-2"
                    @click="$router.push({ name: 'models.view', params: { id: formData.model_id ?? model_id } })"><i
                        class="bi bi-x-circle me-1"></i>Annuler</button>

            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
import Backlink from '@/components/partials/Backlink.vue';
export default {
    name: 'TissuForm',
    mixins: [formMixin],
    props: {
        model_id: {
            type: [String, Number],
            required: true
        }
    },
    components: {
        Backlink
    },
    data() {
        return {
            defaultData: {
                quantity: 1
            },
            url: '/tissus',
            tissuTypes: [],

            isLoading: false,
            fullPage: true
        }
    },
    computed: {
        imageUrl() {
            return this.imageLink('image');
        }
    },

    methods: {
        beforeSave() {
            this.formData.style_id = this.model_id;
        },
        getTissuTypes() {
            this.$api.get('/type-tissus').then(response => {
                this.tissuTypes = response.data.data;
            })
        },
    },

    created() {
        this.getTissuTypes();
    }

}
</script>